const normalizeString = (str: string) =>
  str.normalize("NFD").replace(/[\u0300-\u036f]/g, "");

export const includesIgnoringAccents = (mainStr: string, searchStr: string) => {
  const normalizedMainStr = normalizeString(mainStr).toLocaleLowerCase();
  const normalizedSearchStr = normalizeString(searchStr).toLocaleLowerCase();
  return normalizedMainStr.includes(normalizedSearchStr);
};
